export const TELEGRAM_URL = "https://t.me/+0gTfnKjK4kY2N2Mx";
export const STRIPE_TOOLKIT_URL = "https://buy.stripe.com/14A28reHV0On0P37wU87K07";
export const CREDIT_REPORT_URL = "https://app.myfreescorenow.com/enroll/B02B9191";
export const CALENDLY_URL = "https://calendly.com/jay11consulting";
export const SUPPORT_EMAIL = "j11consulting@gmail.com";

export const calendlyUrl = ({ name, email }) => `${CALENDLY_URL}?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}`;
